export default __webpack_public_path__ + "static/card_02-2a3de8f62036f825f3e56153ab25413b.png";